export default "__VITE_ASSET__mcQrUx1Y__"